<svelte:head>

    <title>Dashboard • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Dashboard from "../components/dashboard.svelte";

</script>

<SessionManager />

<section>

    <Dashboard/>

</section>

<style>

    section {
        height: inherit;
    }

</style>
